import React from 'react';
import { View, Text, TouchableOpacity, StyleSheet } from 'react-native';
import { MAIN_BORDER_COLOR, MAIN_BORDER_COLOR_STRING, cx } from './common';
import { Grid } from '@mui/material';
import { AntDesign } from '@expo/vector-icons';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import { ScrollView } from "@constants/Themed";

export type CustomBlockManagerProps = {
  mapCategoryBlocks: Map<string, any[]>;
  dragStart: (block: any, nativeEvent: any) => void;
  dragStop: (arg0: boolean) => void;
};

const CustomBlockManager = ({
  mapCategoryBlocks,
  type,
  dragStart,
  dragStop,
}: CustomBlockManagerProps & { type?: string }) => {
  return (
    <>
      <style>{`
        .gjs-block {
          transition: all 0.2s ease;
        }
        .gjs-block:hover {
          background-color: #f0f0f0 !important;
          box-shadow: 0 2px 8px rgba(0,0,0,0.1);
        }
        .gjs-block:active {
          transform: scale(0.95);
          cursor: grabbing !important;
        }
        .gjs-block[draggable="true"] {
          cursor: grab;
        }
        .gjs-block[draggable="true"]:active {
          cursor: grabbing;
        }
        .gjs-block * {
          pointer-events: none;
        }
        .gjs-block[draggable="true"] * {
          pointer-events: none;
        }
      `}</style>
      <ScrollView style={{ maxHeight: '80vh' }} contentContainerStyle={{ paddingBottom: 150 }}>
        {Array.from(mapCategoryBlocks).map(([category, blocks], index) => {
          return (
            <Accordion style={{}} key={category} defaultExpanded={index === 0}>
              <AccordionSummary
                expandIcon={<AntDesign name="down" size={24} color="white" />}
                aria-controls={`${category}-content`}
                id={`${category}-header`}
                style={{ backgroundColor: MAIN_BORDER_COLOR_STRING, }}
              >
                <Text style={{ color: "white", fontWeight: "bold" }}>
                  {category}
                </Text>
              </AccordionSummary>
              <AccordionDetails style={{ padding: 40, paddingRight: 25, paddingLeft: 25 }}>
                <Grid
                  container
                  spacing={{ xs: 1, sm: 2, md: 3 }}
                  style={{ flex: 1, alignSelf: "center", gap: 6 }}
                >
                  {blocks.map((block, blockIndex) => {
                    console.log(`Rendering block ${blockIndex}: ${block.getLabel()} in category: ${category}`);
                    return (
                      <div
                        key={block.getId()}
                        className="gjs-block"
                        style={{
                          ...styles.block,
                          overflow: "hidden",
                          padding: 5,
                          backgroundColor: "#ececec",
                          cursor: "grab",
                          userSelect: "none",
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          justifyContent: "center",
                          borderRadius: 5,
                          minWidth: 90,
                          minHeight: 90,
                          maxHeight: 110,
                          border: "1px solid #ddd",
                          transition: "all 0.2s ease"
                        }}
                        onDragStart={(ev) => {
                          console.log('Drag start for block:', block.getLabel());
                          dragStart(block, ev);
                        }}
                        onDragEnd={(ev) => {
                          console.log('Drag end for block:', block.getLabel());
                          dragStop(false);
                        }}
                        draggable={true}
                        onMouseDown={(ev) => {
                          ev.currentTarget.style.cursor = "grabbing";
                          ev.currentTarget.style.transform = "scale(0.95)";
                        }}
                        onMouseUp={(ev) => {
                          ev.currentTarget.style.cursor = "grab";
                          ev.currentTarget.style.transform = "scale(1)";
                        }}
                        onMouseLeave={(ev) => {
                          ev.currentTarget.style.cursor = "grab";
                          ev.currentTarget.style.transform = "scale(1)";
                        }}
                      >
                        <div
                        style={{
                          flex: 4,
                          top: -5,
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center"
                        }}
                        dangerouslySetInnerHTML={{ __html: block.getMedia()! }}
                      />
                      <div
                        style={{
                          flex: 1,
                          maxWidth: 80,
                          textAlign: "center",
                          top: block.getLabel() === "2 Columns 3/7" ? -13 : 0,
                          fontSize: 12,
                          fontWeight: "normal",
                          color: "#333",
                          wordWrap: "break-word",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap"
                        }}
                        id={block.getLabel()}
                      >
                        {block.getLabel()}
                      </div>
                    </div>
                  );
                })}
                </Grid>
              </AccordionDetails>
            </Accordion>
          );
        })}
    </ScrollView >
    </>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    margin: -10,
  },
  categoryHeader: {
    paddingVertical: 10,
    paddingHorizontal: 20,
  },
  blockContainer: {
    flexDirection: 'row',
    paddingVertical: 10,
    paddingHorizontal: 20,
  },
  block: {
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: "center",
    alignContent: "center",
    alignSelf: "center",
    padding: 15,
    borderRadius: 5,
    minWidth: 90,
    flex: 1,
    minHeight: 90,
    maxHeight: 110
  },
  mediaContainer: {
    width: 50,
    height: 50,
    marginTop: -15,
    alignSelf: 'center',
    alignContent: 'center',
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    maxHeight: 40
  },
  label: {
    fontSize: 12,
    alignSelf: "stretch",
    textAlign: 'center',
    flex: 1,
    minWidth: "100%"
  },
});

export default CustomBlockManager;
